const Container = ({ children, className, height }) => {
  const style = height ? { height: `${height}px` } : {};

  return (
    <section style={style} className={`${className} p-default`}>
      {children}
    </section>
  );
};

export default Container;
